import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Input, Popconfirm, message, Select, Upload, Modal } from 'antd';
import { Field, reduxForm } from 'redux-form';

const FormItem = Form.Item;

class CategoryModal extends Component {

    constructor(props) {
        super(props);
        
        // hide warning
        this.state = {
            didInitialized: false
        };
    }
    

    static getDerivedStateFromProps(nextProps, prevState) {

        const { initialCategory, initialize } = nextProps;
        if (initialCategory && !prevState.didInitialized) {
            initialize(initialCategory);
            console.log('update')

            return { didInitialized: true };
        }
        console.log('create')

        return null;
    }

    submitForm(values) {
        this.props.onAdd(values, !this.props.initialCategory);
    }

    renderDelete(category) {
        if (category) {
            return (
                <div className="delete-link">
                    <a onClick={() => this.props.onDeleteClick(category)}>Delete this Category </a>
                </div>
            );
        }
    }

    renderField(field) {
        const { meta: { touched, error }, input } = field;
        const className = `form-group input-txt`;
        const validationStatus = `${touched ? (error ? 'error' : 'success') : ''}`;
        const help = `${touched && error ? error : ''}`;

        return (
            <FormItem
                label={field.label}
                colon
                className={className}
                validateStatus={validationStatus}
                help={help}
                hasFeedback={field.required}
                required={field.required}
            >
                <Input
                    {...input}
                    className="form-control"
                    placeholder={field.placeholder}
                    size="large"
                    type="text"
                    addonBefore={field.addonBefore}
                />
            </FormItem>
        );
    }

    render() {
        const { initialCategory, onCancel, handleSubmit } = this.props;

        return (
            <div className="modal-body">
                <form onSubmit={handleSubmit(this.submitForm.bind(this))}>
                    <h3>{initialCategory ? 'Edit Category' : 'New Category'}</h3>
                    <Field
                        name="name_zh"
                        label="Category Name (ZH)"
                        placeholder="Category Name (Chinese)"
                        component={this.renderField}
                        required
                    />
                    <Field
                        name="name_en"
                        label="Category Name (EN)"
                        placeholder="Category Name (English)"
                        component={this.renderField}
                        required
                    />
                    <Field
                        name="name_th"
                        label="Category Name (TH)"
                        placeholder="Category Name (Thai)"
                        component={this.renderField}
                        required
                    />
                    {this.renderDelete(initialCategory)}
                    <div className="modal-botton">
                        <button
                            className="btn button gray-btn"
                            onClick={(e) => {
                                e.preventDefault();
                                onCancel();
                            }}
                        >Cancel</button>
                        <button
                            className="btn button green-btn"
                            type="submit"
                        >
                            {initialCategory ? 'Save' : 'Add Category'}
                        </button>
                    </div>
                </form>
            </div>
        )
    }
}

function validate(values) {
    const errors = {};

    if (!values.name_en) {
        errors.name_en = 'Category Name cannot be empty';
    }
    if (!values.name_th) {
        errors.name_th = 'Category Name cannot be empty';
    }
    if (!values.name_zh) {
        errors.name_zh = 'Category Name cannot be empty';
    }

    return errors;
}

CategoryModal = reduxForm({
    validate,
    form: 'CategoryForm',
    enableReinitialize: false
})(CategoryModal);

export default CategoryModal;



// WEBPACK FOOTER //
// ./src/views/products/CategoryModal.js